require('./_typed-array')('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/es6.typed.int32-array.js
// module id = 398
// module chunks = 99